import TokensView from './TokensView'

export default TokensView
